export default function Email(props) {
  return (
    <a href={"mailto:" + props.children}>
      <span id="a11y-email">
        <strong>{props.children}</strong>
      </span>
    </a>
  );
}
